import { TableBody, TableCell, TableRow } from "@mui/material";
import React from "react";

const BarcodesTableBody = ({ barcodes = [] }) => {
  const sx = {
    fontSize: "10px !important",
    padding: "0px 5px !important",
  };
  return (
    <TableBody>
      {barcodes?.map(({ barcode, partName }) => (
        <TableRow>
          <TableCell sx={sx}>{barcode}</TableCell>
          <TableCell sx={sx}>{partName}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};

export default BarcodesTableBody;
